import { CopyTextToClipboardOptions } from './types'

export const copyTextToClipboardFallback = (
    text: string,
    options?: CopyTextToClipboardOptions
) => {
    // MUI locks focus inside popups. Set disableEnforceFocus={true} or specify container inside popup to make textArea focusable.
    const container = options?.container ?? document.body

    const textArea = document.createElement('textarea')

    textArea.value = text

    textArea.style.opacity = '0'
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'
    textArea.style.zIndex = '999999'

    container.appendChild(textArea)

    const focusElement =
        document.activeElement !== document.body
            ? (document.activeElement as unknown as HTMLOrSVGElement)
            : null

    try {
        textArea.focus()
        textArea.select()
        return document.execCommand('copy')
    } catch {
        return false
    } finally {
        container.removeChild(textArea)
        focusElement?.focus?.()
    }
}
